{
  "fields": {
    "email": "Email",
    "password": "Password"
  },
  "signIn": {
    "title": "Sign in",
    "forgot": "Forgot your password?",
    "submit": "Sign in",
    "enterEmail": "Enter your email.",
    "enterPassword": "Enter your password.",
    "lead": "Delve Workshop is for the portal's admins: sign in with your Delve account.",
    "noAccount": "No account? The workshop has none of its own: it uses delve-portal's."
  },
  "adminsOnly": {
    "title": "Admins only",
    "lead": "Delve Workshop is for the portal's admins. Ask an admin to promote your account.",
    "signOut": "Sign out"
  }
}
